import React from 'react';
import { Grid, Box, Paper, Typography } from '@mui/material';
import LoginForm from '../components/LoginForm';
import logoImg2 from '../images/bastas_logo2.png';

function LoginPage() {
  return (
    <Box 
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Grid
        container
        sx={{
          flex: 1, // makes the Grid fill remaining space so the footer sits at the bottom
          background: 'linear-gradient(135deg, #f3f4f8 0%, #c3d0e2 100%)',
        }}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12} md={5}>
          <Paper
            elevation={10}
            sx={{
              p: 4,
              m: 2,
              borderRadius: 3,
              boxShadow: '0px 4px 20px rgba(0,0,0,0.2)',
              textAlign: 'center',
            }}
          >
            <Box sx={{ mb: 3 }}>
              <img
                src={logoImg2}
                alt="Logo"
                style={{
                  width: '60px',
                  maxWidth: '100%',
                  marginBottom: '16px',
                }}
              />
              <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                BaştaşPay
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Güvenli ödeme sistemine giriş yapın
              </Typography>
            </Box>

            {/* Login formunu bozmayın */}
            <LoginForm />
          </Paper>
        </Grid>
      </Grid>

      {/* Footer */}
      <Box
        component="footer"
        sx={{ p: 2, textAlign: 'center', bgcolor: '#f5f5f5' }}
      >
        <Typography variant="caption" color="text.secondary">
          © 2025 Duyu Payment System
        </Typography>
      </Box>
    </Box>
  );
}

export default LoginPage;
